import React, { useRef, useState, useEffect } from "react";


const Ads = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);


  return (
    <div className="display-container">
      <div className="video-wrapper">
        <video
          ref={videoRef}
          className="responsive-video"
          autoPlay
          loop
          muted={isMuted}
          playsInline
          preload="auto"
        >
          <source
            src={
              "https://storage.googleapis.com/pllayer-assests/panda-pickleball/Panda_Video.MP4"
            }
            type="video/mp4"
          />
        </video>
     
      </div>
    </div>
  );
};

export default Ads;
